function buildPayload(
	values: NavigationItemFormValues,
	imageReference: string | null,
	imageRemoved: boolean
): Record<string, unknown> {
	const isGridParent = values.layout === "grid" && !values.parent;
	const hasFeed = Boolean(values.feedId);
	const rawUrl = hasFeed || isGridParent ? "" : values.url || "";
	const url =
		rawUrl && !/^https?:\/\//i.test(rawUrl) ? `https://${rawUrl}` : rawUrl;
	const hasUrl = Boolean(url);

	return {
		name: values.name,
		description: values.description,
		permalink: values.permalink || null,
		parent: values.parent || null,
		url,
		web: hasUrl ? values.web : false,
		webview: hasUrl ? !values.web : false,
		feed_id: hasFeed ? values.feedId : null,
		published: values.published,
		layout: values.layout || null,
		image_reference: imageReference ?? null,
		image_removed: imageRemoved
	};
}

export const adaptCreateNavigationItemPayload = (
	values: NavigationItemFormValues,
	imageReference: string | null
): Record<string, unknown> => {
	return buildPayload(values, imageReference, false);
};

export const adaptEditNavigationItemPayload = (
	values: NavigationItemFormValues,
	imageReference: string | null,
	imageRemoved = false
): Record<string, unknown> => {
	return buildPayload(values, imageReference, imageRemoved);
};
